export default __webpack_public_path__ + "static/fin-identity-kyc-e896370212283b1994778cad00ac8f32.png";